module.exports = __webpack_public_path__ + "static/media/(LH)_MG_6233_-_Joias_Contenporaneas.1bbe1911.jpg";